/**
 * Newsletter signup popup for homepage.
 * Requires: jQuery, jquery-confirm. Expects window.FM_SHOW_NEWSLETTER (boolean) set by template.
 */
(function () {
    if (!window.FM_SHOW_NEWSLETTER || typeof jQuery === 'undefined') return;
    var $ = jQuery;
    $(document).ready(function () {
        if (localStorage.getItem('flooringmarket.com-doNotShowNewsletterPopup') === 'true') return;
        $.confirm({
            title: 'Stay Inspired',
            type: 'red',
            closeIcon: true,
            backgroundDismiss: true,
            content:
                '<form id="newsletterForm" class="newsletterForm">' +
                '<div class="form-group">' +
                '<label>Join our mailing list to receive <u>$25 off</u> your next order</label><br />' +
                '<label style="margin-top: 10px;">First Name: </label><br />' +
                '<input type="text" placeholder="First name" name="firstName" id="firstName" class="name firstName form-control line-item-property__field" required />' +
                '<label style="margin-top: 10px;">Last Name: </label><br />' +
                '<input type="text" placeholder="Last name" name="lastName" id="lastName" class="name lastName form-control line-item-property__field" required />' +
                '<label style="margin-top: 10px;">Email: </label><br />' +
                '<input type="email" placeholder="Email" name="email" id="email" class="email form-control line-item-property__field" required />' +
                "<p class='line-item-property__field'>" +
                '<label style="margin-top: 10px;">Please Describe Yourself</label><br>' +
                "<select required name='customerType' id='customerType' class='customerType'>" +
                "<option value='Homeowner'>I am a Homeowner</option>" +
                "<option value='Pro'>I am a Pro</option>" +
                "<option value='Designer'>I am a Designer</option>" +
                '</select>' +
                '</p>' +
                '</div>' +
                '</form>',
            buttons: {
                formSubmit: {
                    text: 'Submit',
                    btnClass: 'btn-blue',
                    action: function () {
                        var name = this.$content.find('.name').val();
                        if (!name) {
                            $.alert('Please provide a valid name');
                            return false;
                        }
                        var email = this.$content.find('.email').val();
                        if (!email) {
                            $.alert('Please provide a valid email!');
                            return false;
                        }
                        $.ajax({
                            type: 'POST',
                            url: 'https://fmprice.com/testbed/sharpspring/fm-sharpspring-newsletter-form-handler.php',
                            data: $('#newsletterForm').serialize(),
                            dataType: 'json',
                            success: function (response) {
                                if (response.errorCode !== 0) {
                                    $.alert('Error: ' + response.errorMsg);
                                } else {
                                    $.alert(
                                        'You have successfully subscribed to our newsletter! <br />Please use the code <code>25OFF</code>!<br /><p style="text-align: center;">Thank you!</p>'
                                    );
                                    localStorage.setItem('flooringmarket.com-successfullySubscribedToNewsletter', 'true');
                                    localStorage.setItem('flooringmarket.com-doNotShowNewsletterPopup', 'true');
                                }
                            },
                            error: function (errMessage) {
                                $.alert('An unexpected error occurred (' + errMessage.errorMsg + '). Please try again later');
                            }
                        });
                    }
                },
                cancel: function () {}
                ,
                stopAsking: {
                    text: "Don't Ask Again",
                    btnClass: 'btn-grey',
                    keys: ['esc'],
                    action: function () {
                        localStorage.setItem('flooringmarket.com-doNotShowNewsletterPopup', 'true');
                    }
                }
            },
            onContentReady: function () {
                var jc = this;
                this.$content.find('form').on('submit', function (e) {
                    e.preventDefault();
                    jc.$$formSubmit.trigger('click');
                });
            }
        });
    });
})();
